import { filtersAccordionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion";
import { css } from "styled-components";

filtersAccordionStyles.accordion = {
    css: css`
        padding-top: 15px;
        min-height: 70vh;
    `,
}